<template>
  <div class="image-choice-item" @click="$emit('click', item)">
    <div class="image-wrap">
      <div v-for="img in item.content.image" :key="img.url" class="h-full image-box">
        <img :src="img.url" alt="" class="max-w-full max-h-full" />
        <van-icon name="search" class="show-icon" @click.stop="previewImage(img.url)" />
      </div>
    </div>
    <div class="pr-3 py-2 pl-10 relative">
      <span class="check-icon">
        <slot name="icon"></slot>
      </span>
      <div class="leading-base" v-html="item.content.richText"></div>
    </div>
    <slot name="vote"/>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  name: 'ImageChoiceItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    previewImage(url) {
      ImagePreview({
        images: [url],
        closeable: true
      })
    }
  }
}
</script>

<style scoped></style>
